import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    opacity: 0,
    y: -10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-[#2D2D2D]/80 backdrop-blur-md border-b border-white/5' : 'bg-transparent'}`} data-id="element-45">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between" data-id="element-46">
        {/* Logo mark */}
        <a href="#hero" className="font-serif text-2xl text-accent leading-none tracking-tight hover:text-accent-bright transition-colors duration-200" aria-label="Power of N Ventures" data-id="element-47">
          PoN
        </a>
      </div>
    </motion.nav>;
}